'use client';

import React, { useRef, useEffect } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

type ElementPopInData = {
  children: JSX.Element;
  delay: number;
};

export default function ElementPopIn(ElementPopInData: ElementPopInData) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
  }, [isInView, mainControls]);

  return (
    <div ref={ref}>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 75 },
          visible: { opacity: 1, y: 0 }
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 1, delay: ElementPopInData.delay }}
      >
        {ElementPopInData.children}
      </motion.div>
    </div>
  );
}
